<ng-container *transloco="let t; read: 'admin.userDetail'">
  @if (user(); as u) {
    <section class="flex max-w-[640px] flex-col gap-4">
      <header class="flex flex-col gap-1">
        <h1 class="font-display text-2xl font-bold text-ink-1">{{ displayName() }}</h1>
        @if (showEmailSubline()) {
          <p class="text-[14px] text-ink-2">{{ u.email }}</p>
        }
      </header>

      <div class="rounded-control border border-hairline bg-card p-5">
        <div class="grid grid-cols-[140px_1fr] items-center gap-x-3 gap-y-3 text-[14px] text-ink-1">
          <span class="text-[11px] font-semibold uppercase tracking-wide text-ink-2">{{ t('firstName') }}</span>
          <span class="truncate">{{ u.firstName || t('empty') }}</span>

          <span class="text-[11px] font-semibold uppercase tracking-wide text-ink-2">{{ t('lastName') }}</span>
          <span class="truncate">{{ u.lastName || t('empty') }}</span>

          <span class="text-[11px] font-semibold uppercase tracking-wide text-ink-2">{{ t('email') }}</span>
          <span class="truncate">{{ u.email || t('empty') }}</span>

          <span class="text-[11px] font-semibold uppercase tracking-wide text-ink-2">{{ t('status') }}</span>
          <span class="flex items-center gap-2">
            <app-label-badge [dot]="u.enabled ? 'green' : null">{{ u.enabled ? t('enabled') : t('disabled') }}</app-label-badge>
            <app-label-badge [dot]="u.emailVerified ? 'green' : null">{{ u.emailVerified ? t('emailVerified') : t('emailUnverified') }}</app-label-badge>
          </span>

          <span class="text-[11px] font-semibold uppercase tracking-wide text-ink-2">{{ t('created') }}</span>
          <span>{{ u.createdAt ? (u.createdAt | date: 'medium') : t('empty') }}</span>

          <span class="self-start text-[11px] font-semibold uppercase tracking-wide text-ink-2">{{ t('organizations') }}</span>
          <span class="flex min-w-0 flex-wrap items-center gap-1.5">
            @for (org of u.organizations; track org.id) {
              <button
                type="button"
                (click)="openOrganization(org)"
                class="max-w-full cursor-pointer transition hover:opacity-75"
              >
                <app-label-badge>{{ org.name }}</app-label-badge>
              </button>
            } @empty {
              <span class="text-ink-3">{{ t('empty') }}</span>
            }
          </span>
        </div>

        <div class="mt-4 h-px bg-hairline"></div>
        <div class="mt-4 break-all font-num text-[12px] text-ink-3">{{ t('userId', { id: u.id }) }}</div>
      </div>
    </section>
  } @else if (isLoading()) {
    <p class="text-[14px] text-ink-2">{{ t('loading') }}</p>
  } @else {
    <p class="text-[14px] text-ink-2">{{ t('notFound') }}</p>
  }
</ng-container>
